import Vue from 'vue';
import Router from 'vue-router';

import RN from '@/config/router';


Vue.use(Router);

// 解决控制台提示"NavigationDuplicated"警告
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }

  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }

  return originalReplace.call(this, location).catch((err) => err);
};

export default function createRouter() {
  const routes = [
    {
      base: `${process.env.PUBLIC_PATH || '/'}`,
      path: '/',
      name: RN.Root,
      redirect: { name: RN.Home },
      component: () => import('@/App.vue'),
      children: [
        {
          path: 'home',
          name: RN.Home,
          component: () => import('@/views/home'),
        },
        // 鸿蒙下载说明页
        {
          path: 'huawei-download-explanation',
          name: RN.HuaweiDownloadExplanation,
          component: () => import('@/views/huawei-download-explanation'),
        },
      ],
    },
  ];

  const router = new Router({
    mode: 'hash',
    routes,
  });

  return router;
}
